import { inject } from '@angular/core';
import { ResolveFn } from '@angular/router';
import { AuthService } from '@core/authentication/auth.service';
import { Observable } from 'rxjs';
import { map, skipWhile, take } from 'rxjs/operators';

// Pure resolver: gates activation until a tenant is known and returns its id.
// The id is seeded into the (component-scoped) OiqTenantStore by HomeComponent,
// so the store's lifetime is tied to the home page rather than a cached route injector.
export const tenantResolver: ResolveFn<number | null> = (): Observable<number | null> => {
  const authService = inject(AuthService);

  return authService.cookieChanges$.pipe(
    map(() => {
      const _user = authService.getUser();
      return _user && _user.tenantId ? _user.tenantId : null;
    }),
    skipWhile(tenantId => !tenantId),
    take(1)
  );
};
